import isEmpty from "./helpers/isEmpty";
import PagedResponse from "./models/PagedResponse";
import caseStudiesFetch from "./api/caseStudiesFetch";
import CaseStudyModel from "./models/CaseStudyModel";

/**
 * Init case studies container
 *
 * @param {string} htmlContainerId
 * @param {string} htmlCaseStudiesListId
 * @param {string} htmlFilterButtonId
 * @param {string} htmlSolutionSelectId
 * @param {string} htmlSectorialSelectId
 * @returns
 */
const initCaseStudiesContainer = (
  htmlContainerId,
  htmlCaseStudiesListId,
  htmlFilterButtonId,
  htmlSolutionSelectId,
  htmlSectorialSelectId
) => {
  const container = document.getElementById(htmlContainerId);
  if (!container) return;

  fetchData(container, htmlCaseStudiesListId);

  $(document).ready(() => {
    $("#loadMorePress").on("click", function (e) {
      e.preventDefault();

      if (window.currentPageNumber < window.lastPageNumber) {
        getDataPress(window.currentPageNumber + 1, PerPageQuery);
      }

      if (window.currentPageNumber == window.lastPageNumber) {
        $("#loadMorePress").text("No more content").addClass("noContent");
      }
    });

    $(`#${htmlFilterButtonId}`).on("click", (e) => {
      e.preventDefault();
      const solutionSelect = document.getElementById(htmlSolutionSelectId);
      const sectorialSelect = document.getElementById(htmlSectorialSelectId);
      if (solutionSelect && sectorialSelect) {
        container.dataset.page = 1;
        container.dataset.solutionId = solutionSelect.value;
        container.dataset.sectorialSolutionId = sectorialSelect.value;
        fetchData(container, htmlCaseStudiesListId);
      }
    });
  });
};

/**
 * Load case studies content.
 *
 * @param {HTMLElement} container - container containing html data variables
 * @param {string} htmlCaseStudiesListId - id of html container containing insights cards
 */
const fetchData = async (container, htmlCaseStudiesListId) => {
  const {
    protocol,
    host,
    apiSuffix,
    folderId,
    page,
    perPage,
    solutionId,
    sectorialSolutionId,
  } = container.dataset;

  const response = await caseStudiesFetch(
    protocol,
    host,
    apiSuffix,
    folderId,
    page,
    perPage,
    solutionId,
    sectorialSolutionId
  );

  if (response.success) {
    const data = !isEmpty(response.data) ? response.data : new PagedResponse();
    printDataPress(container, data, htmlCaseStudiesListId, data.currentPageNumber === 1);
  } else {
    printDataPress(container, new PagedResponse(), htmlCaseStudiesListId, true);
  }
};

/**
 *
 * @param {HTMLElement} container - container containing html data variables
 * @param {PagedResponse} pagedResponse - class model of paged response
 * @param {string} htmlCaseStudiesListId - id of html container containing news cards
 * @param {bool} resetHtml - should html containing card be reset
 */
function printDataPress(
  container,
  pagedResponse,
  htmlCaseStudiesListId,
  resetHtml = false
) {
  const caseStudiesListContainer = document.getElementById(
    htmlCaseStudiesListId
  );
  if (!caseStudiesListContainer) return;

  if (container.dataset.perRow) {
    caseStudiesListContainer.style.setProperty(
      "--perRow",
      container.dataset.perRow
    );
  }

  let html = !resetHtml ? caseStudiesListContainer.innerHTML : "";
  if (pagedResponse && pagedResponse.results && pagedResponse.results.length) {
    pagedResponse.results.forEach((element) => {
      if (element instanceof CaseStudyModel) {
        html += element.generateCaseStudyCard();
      }
    });
  } else {
    html = pagedResponse.generateNoResults(container.dataset.perRow, 4);
  }
  caseStudiesListContainer.innerHTML = html;
  const infinityScroll = pagedResponse.createInfinityScroll(
    caseStudiesListContainer.nextElementSibling,
    container,
    () => fetchData(container, htmlCaseStudiesListId)
  );
  caseStudiesListContainer.insertAdjacentElement("afterend", infinityScroll);
}

initCaseStudiesContainer(
  "caseStudiesContainer",
  "caseStudiesGeneralList",
  "caseStudiesFilterButton",
  "caseStudiesSolution",
  "caseStudiesSectorial"
);

export default initCaseStudiesContainer;
